import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListHealthUnitSelectResponse } from '../../responses/user/list-health-unit-select.response';

@Injectable({
  providedIn: 'root'
})
export class ListHealthUnitService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listHealthUnit(searchText: string, idHealthUnitGroup: number): Observable<ListHealthUnitSelectResponse> {
    
    let uri = 'ListHealthUnit?'
  
    if(searchText != null)
    uri = uri+ `searchText=${searchText}&`;

    if(idHealthUnitGroup != null)
    uri = uri+ `idHealthUnitGroup=${idHealthUnitGroup}&`;
    
    return this.httpClient.get<ListHealthUnitSelectResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
    
    